import React, { useState } from 'react'
import Header from '../../components/Header in Page/_Header'
import NewHeader from '../../components/New Header/NewHeader'
import { ReactComponent as Check } from "../../assets/new-icons/check_simple.svg";
import './_consumi.scss'
import ViewMonth from '../../components/Consumi/ViewMonth/ViewMonth';
import ViewYear from '../../components/Consumi/ViewYear/ViewYear';
import ViewWeek from '../../components/Consumi/ViewWeek/ViewWeek';

function NewConsumi() {
    const views = [
        {
            state: 'month', label: 'Mese'
        }, 
        {
            state: 'year', label: 'Anno'
        }, 
        {
            state: 'week', label: 'Settimana'
        }, 
    ]
    const [viewSelected, setViewSelected] = useState('month')
  return (
    <div className='consumi'>
        <div className="consumi-top">
            <NewHeader logo='white' padding='no' iconsColor='white'/>
        </div>
        <div className="consumi-bottom">
            <Header
              title="Consumi"
              description={`Qui verranno riportati i tuoi dati. Tieni sotto controllo le tue utenze e scopri i tuoi consumi.`}
              icon="consumi"
            />
            <div className="reali_label">
                <Check/>
                <p>Reali disponibili quando presente questo simbolo</p>
            </div>
            <div className="view_label">
                {views.map((view, i) => (
                    <p key={i} onClick={() => setViewSelected(view.state)} style={viewSelected === view.state ? {color: '#697386'} : null}>{view.label}</p>
                ))}
            </div>
            {
                viewSelected === 'month' ? (
                    <ViewMonth />
                ) :  viewSelected === 'year' ? (
                    <ViewYear />
                ) : <ViewWeek />
            }
            <div className="empty" style={{height: '100px'}}></div>
        </div>
    </div>
  )
}

export default NewConsumi